module.exports = __webpack_public_path__ + "img/objects-align-center-vertical.d80f51d8.svg";